import { IdVerification } from '../../models';
import { RejoiningParticipant } from '../../models/rejoining-participant.model';

export interface State {
  allSignersApproved: boolean;
  idVerifications: IdVerification[];
  approvedPackageUserGuids: string[];
  rejoiningUsers: RejoiningParticipant[];
  isAllSignersApprovedInfoLoaded: boolean;
}

export const initialState: State = {
  allSignersApproved: false,
  approvedPackageUserGuids: [],
  rejoiningUsers: [],
  idVerifications: null,
  isAllSignersApprovedInfoLoaded: false,
};
